import React, { useState, useEffect, useRef, useCallback } from 'react';
import { makerVariant } from '../variant-resolver.tsx';
const stores = [{
  name: 'Coyuchi',
  image: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/coyuchi-1k1et9ogjod.png',
  href: '#'
}, {
  name: 'Nicobar',
  image: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/nicobar-7woozmn516w.png',
  href: '#'
}];
const VIMEO_NICOBAR = 'https://player.vimeo.com/video/1180508434?badge=0&autopause=0&player_id=0&app_id=58479';
const VIMEO_COYUCHI = 'https://player.vimeo.com/video/1180715533?badge=0&autopause=0&player_id=0&app_id=58479';
const VideoModal = ({
  src,
  aspectRatio,
  title,
  onClose
}: {
  src: string;
  aspectRatio: string;
  title: string;
  onClose: () => void;
}) => {
  const [visible, setVisible] = useState(false);
  const [iframeSrc, setIframeSrc] = useState(src);
  const overlayRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    requestAnimationFrame(() => setVisible(true));
  }, []);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') handleClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);
  const handleClose = useCallback(() => {
    setIframeSrc('');
    setVisible(false);
    setTimeout(onClose, 250);
  }, [onClose]);
  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === overlayRef.current) handleClose();
  };
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
  return <div ref={overlayRef} onClick={handleOverlayClick} style={{
    position: 'fixed',
    inset: 0,
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(9, 23, 23, 0.75)',
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
    opacity: visible ? 1 : 0,
    transition: 'opacity 250ms ease',
    pointerEvents: 'auto',
    padding: 0,
    overflow: 'visible'
  }}>
    <div style={{
      position: 'relative',
      width: isMobile ? '95vw' : '90vw',
      maxWidth: '1280px',
      margin: '0 auto',
      background: '#091717',
      borderRadius: 0,
      flexShrink: 0
    }}>
      <button onClick={handleClose} aria-label="Close video" style={{
        position: 'absolute',
        top: '-40px',
        right: 0,
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontFamily: 'Instrument Sans, sans-serif',
        fontWeight: 400,
        fontSize: '24px',
        color: '#FCFAF6',
        lineHeight: 1,
        padding: 0
      }} data-tracking-id="btn-3b0421ef693b03c8">×</button>
      <div style={{
        padding: `${aspectRatio} 0 0 0`,
        position: 'relative'
      }}>
        <iframe src={iframeSrc} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%'
        }} title={title} />
      </div>
    </div>
  </div>;
};
const arrowImg = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/image-arrow-dhxc1f5xkqb.png';
const arrowStyle: React.CSSProperties = {
  display: 'inline-block',
  width: '1em',
  height: '1em',
  objectFit: 'contain',
  verticalAlign: 'middle',
  marginLeft: '4px'
};
const demoBtnStyle: React.CSSProperties = {
  fontFamily: 'Instrument Sans, sans-serif',
  fontWeight: 400,
  fontSize: '18px',
  color: '#091717',
  textDecoration: 'none'
};
export const StoreShowcase = () => {
  const [activeModal, setActiveModal] = useState<'nicobar' | 'coyuchi' | null>(null);
  const [windowWidth, setWindowWidth] = useState(() => typeof window !== 'undefined' ? window.innerWidth : 1440);
  useEffect(() => {
    const handler = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  const isMobile = windowWidth <= 767;
  return <>
      <section data-name="Store Showcase" data-nav-theme="light" style={{
      backgroundColor: '#FCFAF6',
      paddingTop: '120px',
      paddingBottom: '120px'
    }}>
        <div className="section-content" style={{
        maxWidth: '1360px',
        margin: '0 auto',
        paddingLeft: '24px',
        paddingRight: '24px'
      }}>
          {/* Section title */}
          <h2 data-name="Section Title" className="section-title store-section-title" style={{
          fontSize: makerVariant('storeSectionFontSize', 'clamp(52px, 7vw, 92px)'),
          lineHeight: 1.05,
          color: '#091717',
          margin: '0 0 44px 0',
          fontWeight: 400
        }}>
            <span style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400
          }}>Stores for humans{' '}</span>
            <span style={{
            fontFamily: 'Instrument Serif, serif',
            fontStyle: 'italic',
            fontWeight: 400
          }}>and agents</span>
          </h2>

          {/* Cards grid */}
          <div data-name="Store Cards" className="store-cards" style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '32px'
        }}>
            {stores.map(store => {
            const key = store.name.toLowerCase() as 'nicobar' | 'coyuchi';
            return <div key={store.name} data-name={`${store.name} Card`}>
                  <div style={{
                aspectRatio: '1 / 1',
                width: '100%',
                overflow: 'hidden',
                borderRadius: '0'
              }}>
                    <img src={store.image} alt={store.name} loading="lazy" decoding="async" style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block'
                }} />
                  </div>
                  <div className="store-label-row" style={{
                marginTop: '20px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'baseline'
              }}>
                    <span className="store-name" style={{
                  fontFamily: 'Instrument Sans, sans-serif',
                  fontWeight: 400,
                  fontSize: '24px',
                  color: '#091717'
                }}>
                      {store.name}
                    </span>
                    <button className="store-demo" onClick={() => setActiveModal(key)} style={{
                  ...demoBtnStyle,
                  ...(isMobile ? {
                    fontSize: '14px',
                    color: '#091717'
                  } : {}),
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0
                }} onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.opacity = '0.5'} onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.opacity = '1'} data-tracking-id="link-fc1221bc0218cb50">
                        Live demo <img src={arrowImg} alt="" aria-hidden="true" style={{
                    ...arrowStyle,
                    ...(isMobile ? {} : {})
                  }} />
                      </button>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </section>
      {activeModal === 'nicobar' && <VideoModal src={VIMEO_NICOBAR} aspectRatio="64.96%" title="Nicobar demo" onClose={() => setActiveModal(null)} />}
      {activeModal === 'coyuchi' && <VideoModal src={VIMEO_COYUCHI} aspectRatio="58.26%" title="Coyuchi demo" onClose={() => setActiveModal(null)} />}
    </>;
};